import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const headCells = [
  {
    id: "No",
    numeric: false,
    disablePadding: false,
    label: "No",
  },
  {
    id: "tanggal-reimburse",
    numeric: false,
    disablePadding: false,
    label: "Tanggal Reimburse",
  },
  {
    id: "tanggal-dibuat",
    numeric: false,
    disablePadding: false,
    label: "Tanggal Dibuat",
  },
  {
    id: "keterangan",
    numeric: false,
    disablePadding: false,
    label: "Keterangan",
  },
  {
    id: "total",
    numeric: false,
    disablePadding: false,
    label: "Total",
  },
  {
    id: "bukti-kwitansi",
    numeric: false,
    disablePadding: false,
    label: "Bukti Kwitansi",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "action_by",
    numeric: false,
    disablePadding: false,
    label: "Action By",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];

const EnhancedTableHead = (props) => {
  return (
    <TableHead
      style={{
        backgroundColor: "#285D5F",
      }}
    >
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            style={{ color: "#fff" }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
